import { render, staticRenderFns } from "./FinanceReportsProfitAndLoss.vue?vue&type=template&id=5f4cbb7f&"
import script from "./FinanceReportsProfitAndLoss.vue?vue&type=script&lang=js&"
export * from "./FinanceReportsProfitAndLoss.vue?vue&type=script&lang=js&"
import style0 from "./FinanceReportsProfitAndLoss.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports